import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import './Product.scss';
import { useEffect, useState, useRef } from 'react';
import BackIcon from '@/assets/rewise/back-icon.svg';
import { useGetProductList } from '../api/getProduct';
import { Product, UserRole, State } from '../types/indes';
import ArrowIcon from '@/assets/steam/arrow-r.svg';
import noDataAnimation from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import Edit from '@/assets/steam/edit.svg';
import { TableData } from '@/components/Table/TableData';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import Utils from '@/utils/util';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useGetStateList, useGetUserRoleList } from '../../users/api/getRefrences';
import { FilterMenu } from '@/components/Elements/FilterMenu';
import EditProduct from '../components/editProduct';
import { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import Delete from '@/assets/steam/delete.svg';
import { useDeleteProduct } from '../api/deleteProduct';

export const Products = () => {
  const [contactList, setContactList] = useState<Product[]>([]);
  const [isAddNewProduct, setIsAddNewProduct] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableCurrentIndex, setTableCurrentIndex] = useState(1);
  const perPage = 10;
  const [searchString, setSearchString] = useState('');
  const [filteredList, setFilteredList] = useState<Product[]>([]);
  const useGetUsersMutation = useGetProductList();
  const [roles, setRoles] = useState<UserRole[]>([]);
  const [states, setStates] = useState<State[]>([]);
  const [editProductData, seteditProductData] = useState<any>(null);
  const useGetUserRoleMutation = useGetUserRoleList();
  const useGetStateMutation = useGetStateList();
  const useDeleteUserMutation = useDeleteProduct();

  useEffect(() => {
    getProductList(1, true);
  }, []);


  const getProductList = async (pageIndex: number, reset = false, filter?: any,isOnlyEdit?: any) => {
    const res = await useGetUsersMutation.mutateAsync({
      page: pageIndex,
      perPage: perPage,
      search: searchString,
      filter,
    });

    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
    if(isOnlyEdit){
      setContactList(res.list);
      if(pageIndex)setTableCurrentIndex(pageIndex);
      if (searchString) {
        setFilteredList(res.list);
      }
    }else if (reset) {
      setContactList(res.list);
      if(pageIndex){
        setTableCurrentIndex(pageIndex);
      }else{
        setTableCurrentIndex(tableCurrentIndex);
      }
      if (searchString) {
        setFilteredList(res.list);
      }
    } else {
      setContactList(contactList.concat(res.list));
      if(pageIndex){
        setTableCurrentIndex(pageIndex);
      }else{
        setTableCurrentIndex(tableCurrentIndex);
      }
    }
  };

  const searchUser = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchString = e.target.value;
    setSearchString(searchString);
    const res = await useGetUsersMutation.mutateAsync({
      page: 1,
      perPage: perPage,
      search: searchString,
    });
    setContactList(res.list);
    if (searchString) {
      setFilteredList(res.list);
    } else {
      setFilteredList([]);
    }
    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
  };

  const actualList = filteredList.length ? filteredList : contactList;

  const onTableStateChange = (pageIndex: number) => {
    if (totalPages >= pageIndex) {
      getProductList(pageIndex, true);
    }
  };

  const resetData = () => {
    seteditProductData(null)
  }

  const getSubject = (entry: any) => {
    if (entry && entry.subject && entry.subject.length > 0) {
      const data = entry.subject
      const subjects = data.map((loc: any) => `${loc.name}`);
      const firstThreeSubjects = subjects.slice(0, 2);
      const remainingCount = subjects.length - 2;

      return {
        firstThreeSubjects,
        remainingCount: remainingCount > 0 ? remainingCount : 0,
      };
    }
    return { firstThreeSubjects: [], remainingCount: 0 };
  };


  const getClasses = (entry: any) => {
    if (entry && entry.subject && entry.subject.length > 0) {
      // Find the subject that matches the given subjectId
      // const subject = entry.subject.find((sub: any) => sub.id === subjectId);

      if (entry.subject && entry.subject.classes && entry.subject.classes.length > 0) {
        // Extract class names
        const classes = entry.subject.classes.map((cls: any) => cls.name);
        const firstThreeClasses = classes.slice(0, 3); // Get the first 3 classes
        const remainingCount = classes.length - 3;

        return {
          firstThreeClasses,
          remainingCount: remainingCount > 0 ? remainingCount : 0,
        };
      }
    }
    return { firstThreeClasses: [], remainingCount: 0 };
  };

  const deleteUser = async (id: any) => {
    const res = await useDeleteUserMutation.mutateAsync({
      id
    });
    if (res) {
      getProductList(1, true);
    }
  }


  return (
    <>

      <div className="users-list-container">
        <PageHeader title='Product List' description='' />
        <div className='search-container'>
          <div className='search-filter-container'>

            <span className="search-content">
              <SearchIcon />
              <input
                type="text"
                id="simple-search"
                placeholder="Search by Product Name..."
                onChange={searchUser}
                className="steam-search"
              />
            </span>

          </div>
          <div className='add-user-container'>
            {<button className='steam-button button-dark' onClick={() => { setIsAddNewProduct(true); }}>Add New Product</button>}

          </div>
        </div>
        <div className="users-list petsked-table">
          {useGetUsersMutation.isLoading && !searchString && (
            <div className="h-full w-full flex items-center justify-center  ">
              <Lottie className="loading-loader-class" animationData={noDataAnimation} />
            </div>
          )}

          <TableData<Product>
            data={actualList}
            columns={[
              {
                title: 'Product Name',
                field: 'name',
                Cell({ entry }) {
                  return (
                    <div className="users-container prodcut-avtar-icon">
                      <div>
                        {/* <InitialsAvatar name={entry && entry.name ? entry.name : 'SA'} className="avatar" /> */}
                        <ProductIcon />
                      </div>
                      <div className="user-details-container">

                        <div className="user-tab-name">
                          <div className="name">{entry?.name}</div>
                        </div>
                      </div>
                    </div>
                  );
                },
              },
              {
                title: 'Subject & Classes',
                field: 'name',
                Cell({ entry }) {
                  return (
                    <div className="table-contact change-display-block">
                      {entry?.subject && entry.subject.length > 0 && entry.subject.sort((a: any, b: any) => a.name.localeCompare(b.name)).map((item: any, subjectIndex: number) => {
                        const classes = item?.classes;
                        return (
                          <>
                            <div key={`subject-${subjectIndex}`} className={`selected-location-details prod-details`}>
                              <div className="state">
                                {item.name} {" "}
                              </div>
                              {/* <div className="state remove-bg">
                                <img src={ArrowIcon} />
                              </div> */}
                              <div className='city'>
                                {classes && classes.length > 0 && classes
                                  .sort((a: any, b: any) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }))
                                  .map((city: any, classIndex: number) => {
                                    return (
                                      <div className='city-name' key={`class-${subjectIndex}-${classIndex}`}>
                                        {city.name}
                                      </div>
                                    );
                                  })}

                              </div>

                            </div>
                          </>
                        );
                      })}
                    </div>

                  );
                },
              },
              {
                title: 'Created At',
                field: 'name',
                Cell({ entry: { createdAt } }) {
                  return (
                    <div className="table-date">
                      {Utils.formatDate(
                        createdAt
                      )}
                    </div>
                  );
                },
              },

              {
                title: 'Action',
                field: 'id',
                Cell({ entry }) {
                  return (
                    <div className="user-btn-container">

                      <div className="edit-btn" onClick={() => { seteditProductData(entry); setIsAddNewProduct(true) }} >
                        <img src={Edit} />
                      </div>
                      <div
                        className="view-btn"
                        onClick={() => {
                          deleteUser(entry.id)
                        }}
                      >
                        <img src={Delete} />
                      </div>
                    </div>
                  );
                },
              },
            ]}
            tableInitialState={{
              tableTotalRecords: totalPages,
              tablePageIndex: tableCurrentIndex,
            }}
            onTableStateChange={onTableStateChange}
            showPagination={true}
            isDataLoading={useGetUsersMutation?.isLoading}
          />
        </div>

        <EditProduct onConfirm={() => { resetData(); setIsAddNewProduct(false); getProductList(tableCurrentIndex, false, null, true) }} onClose={() => { resetData(); setIsAddNewProduct(false); }} open={isAddNewProduct} editProductData={editProductData} />

      </div>

    </>
  );
};
